export default __webpack_public_path__ + "static/media/mystery-silver-ticket.f687b39e.png";